const _c0 = ["header"];
const _c1 = ["footer"];
const _c2 = ["content"];
const _c3 = ["closeicon"];
const _c4 = ["headless"];
const _c5 = ["container"];
const _c6 = ["closeButton"];
const _c7 = ["*"];
function Drawer_Conditional_0_Conditional_2_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function Drawer_Conditional_0_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, Drawer_Conditional_0_Conditional_2_ng_container_0_Template, 1, 0, "ng-container", 4);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.headlessTemplate || ctx_r1._headlessTemplate);
  }
}
function Drawer_Conditional_0_Conditional_3_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function Drawer_Conditional_0_Conditional_3_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMap(ctx_r1.cx("title"));
    i0.ɵɵproperty("pBind", ctx_r1.ptm("title"));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.header);
  }
}
function Drawer_Conditional_0_Conditional_3_p_button_3_ng_template_1__svg_svg_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "svg", 12);
  }
  if (rf & 2) {
    i0.ɵɵattribute("data-pc-section", "closeicon");
  }
}
function Drawer_Conditional_0_Conditional_3_p_button_3_ng_template_1_1_ng_template_0_Template(rf, ctx) {}
function Drawer_Conditional_0_Conditional_3_p_button_3_ng_template_1_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, Drawer_Conditional_0_Conditional_3_p_button_3_ng_template_1_1_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function Drawer_Conditional_0_Conditional_3_p_button_3_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, Drawer_Conditional_0_Conditional_3_p_button_3_ng_template_1__svg_svg_0_Template, 1, 1, "svg", 11)(1, Drawer_Conditional_0_Conditional_3_p_button_3_ng_template_1_1_Template, 1, 0, null, 4);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("ngIf", !ctx_r1.closeIconTemplate && !ctx_r1._closeIconTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.closeIconTemplate || ctx_r1._closeIconTemplate);
  }
}
function Drawer_Conditional_0_Conditional_3_p_button_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-button", 10);
    i0.ɵɵlistener("onClick", function Drawer_Conditional_0_Conditional_3_p_button_3_Template_p_button_onClick_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.close($event));
    })("keydown.enter", function Drawer_Conditional_0_Conditional_3_p_button_3_Template_p_button_keydown_enter_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.close($event));
    });
    i0.ɵɵtemplate(1, Drawer_Conditional_0_Conditional_3_p_button_3_ng_template_1_Template, 2, 2, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("pt", ctx_r1.ptm("pcCloseButton"))("ngClass", ctx_r1.cx("pcCloseButton"))("buttonProps", ctx_r1.closeButtonProps)("ariaLabel", ctx_r1.ariaCloseLabel)("unstyled", ctx_r1.unstyled());
    i0.ɵɵattribute("data-pc-group-section", "iconcontainer");
  }
}
function Drawer_Conditional_0_Conditional_3_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function Drawer_Conditional_0_Conditional_3_ng_container_7_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function Drawer_Conditional_0_Conditional_3_ng_container_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 5);
    i0.ɵɵtemplate(2, Drawer_Conditional_0_Conditional_3_ng_container_7_ng_container_2_Template, 1, 0, "ng-container", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("pBind", ctx_r1.ptm("footer"))("ngClass", ctx_r1.cx("footer"));
    i0.ɵɵattribute("data-pc-section", "footer");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.footerTemplate || ctx_r1._footerTemplate);
  }
}
function Drawer_Conditional_0_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵtemplate(1, Drawer_Conditional_0_Conditional_3_ng_container_1_Template, 1, 0, "ng-container", 4)(2, Drawer_Conditional_0_Conditional_3_div_2_Template, 2, 4, "div", 6)(3, Drawer_Conditional_0_Conditional_3_p_button_3_Template, 3, 6, "p-button", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 5);
    i0.ɵɵprojection(5);
    i0.ɵɵtemplate(6, Drawer_Conditional_0_Conditional_3_ng_container_6_Template, 1, 0, "ng-container", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, Drawer_Conditional_0_Conditional_3_ng_container_7_Template, 3, 4, "ng-container", 8);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("pBind", ctx_r1.ptm("header"))("ngClass", ctx_r1.cx("header"));
    i0.ɵɵattribute("data-pc-section", "header");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.headerTemplate || ctx_r1._headerTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.header);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showCloseIcon && ctx_r1.closable);
    i0.ɵɵadvance();
    i0.ɵɵproperty("pBind", ctx_r1.ptm("content"))("ngClass", ctx_r1.cx("content"));
    i0.ɵɵattribute("data-pc-section", "content");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.contentTemplate || ctx_r1._contentTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.footerTemplate || ctx_r1._footerTemplate);
  }
}
function Drawer_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3, 0);
    i0.ɵɵlistener("pMotionOnBeforeEnter", function Drawer_Conditional_0_Template_div_pMotionOnBeforeEnter_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onBeforeEnter($event));
    })("pMotionOnAfterLeave", function Drawer_Conditional_0_Template_div_pMotionOnAfterLeave_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onAfterLeave($event));
    })("keydown", function Drawer_Conditional_0_Template_div_keydown_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onKeyDown($event));
    });
    i0.ɵɵconditionalCreate(2, Drawer_Conditional_0_Conditional_2_Template, 1, 1, "ng-container")(3, Drawer_Conditional_0_Conditional_3_Template, 8, 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵstyleMap(ctx_r1.style);
    i0.ɵɵclassMap(ctx_r1.cn(ctx_r1.cx("root"), ctx_r1.styleClass));
    i0.ɵɵproperty("pBind", ctx_r1.ptm("root"))("pMotion", ctx_r1.visible)("pMotionAppear", true)("pMotionEnterActiveClass", ctx_r1.$enterAnimation())("pMotionLeaveActiveClass", ctx_r1.$leaveAnimation())("pMotionOptions", ctx_r1.computedMotionOptions());
    i0.ɵɵattribute("data-p", ctx_r1.dataP)("data-p-open", ctx_r1.visible);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.headlessTemplate || ctx_r1._headlessTemplate ? 2 : 3);
  }
}
export * from 'primeng/types/drawer';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Injectable, InjectionToken, inject, input, computed, EventEmitter, booleanAttribute, numberAttribute, ContentChildren, ContentChild, ViewChild, Output, Input, ViewEncapsulation, ChangeDetectionStrategy, Component, NgModule } from '@angular/core';
import { setAttribute, addClass, removeClass, appendChild } from '@primeuix/utils';
import { SharedModule, PrimeTemplate } from 'primeng/api';
import { BaseComponent, PARENT_INSTANCE } from 'primeng/basecomponent';
import * as i1 from 'primeng/bind';
import { Bind } from 'primeng/bind';
import { Button } from 'primeng/button';
import { blockBodyScroll, unblockBodyScroll } from 'primeng/dom';
import * as i3 from 'primeng/focustrap';
import { FocusTrapModule } from 'primeng/focustrap';
import { TimesIcon } from 'primeng/icons';
import * as i4 from 'primeng/motion';
import { MotionModule } from 'primeng/motion';
import { ZIndexUtils } from 'primeng/utils';
import { style as style$1 } from '@primeuix/styles/drawer';
import { BaseStyle } from 'primeng/base';
const style = /*css*/`
${style$1}

/** For PrimeNG **/
.p-drawer {
    position: fixed;
}

.p-drawer-left {
    top: 0;
    left: 0;
    width: 20rem;
    height: 100%;
    border-inline-end-width: 1px;
}

.p-drawer-right {
    top: 0;
    right: 0;
    width: 20rem;
    height: 100%;
    border-inline-start-width: 1px;
}

.p-drawer-top {
    top: 0;
    left: 0;
    width: 100%;
    height: 10rem;
    border-block-end-width: 1px;
}

.p-drawer-bottom {
    bottom: 0;
    left: 0;
    width: 100%;
    height: 10rem;
    border-block-start-width: 1px;
}

.p-drawer-full {
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    -webkit-transition: none;
    transition: none;
}

/* Animations */
.p-drawer-enter-left {
    animation: p-animate-drawer-enter-left 0.5s cubic-bezier(0.32, 0.72, 0, 1);
}

.p-drawer-leave-left {
    animation: p-animate-drawer-leave-left 0.5s cubic-bezier(0.32, 0.72, 0, 1);
}

.p-drawer-enter-right {
    animation: p-animate-drawer-enter-right 0.5s cubic-bezier(0.32, 0.72, 0, 1);
}

.p-drawer-leave-right {
    animation: p-animate-drawer-leave-right 0.5s cubic-bezier(0.32, 0.72, 0, 1);
}

.p-drawer-enter-top {
    animation: p-animate-drawer-enter-top 0.5s cubic-bezier(0.32, 0.72, 0, 1);
}

.p-drawer-leave-top {
    animation: p-animate-drawer-leave-top 0.5s cubic-bezier(0.32, 0.72, 0, 1);
}

.p-drawer-enter-bottom {
    animation: p-animate-drawer-enter-bottom 0.5s cubic-bezier(0.32, 0.72, 0, 1);
}

.p-drawer-leave-bottom {
    animation: p-animate-drawer-leave-bottom 0.5s cubic-bezier(0.32, 0.72, 0, 1);
}

.p-drawer-enter-full {
    animation: p-animate-drawer-enter-full 0.5s cubic-bezier(0.32, 0.72, 0, 1);
}

.p-drawer-leave-full {
    animation: p-animate-drawer-leave-full 0.5s cubic-bezier(0.32, 0.72, 0, 1);
}
`;
const classes = {
  mask: ({
    instance
  }) => ['p-drawer-mask', {
    [`p-overlay-mask p-overlay-mask-enter-active`]: instance.modal
  }, {
    'p-drawer-full': instance.fullScreen()
  }],
  root: ({
    instance
  }) => ['p-drawer p-component', {
    'p-drawer-full': instance.fullScreen(),
    'p-drawer-open': instance.visible
  }, `p-drawer-${instance.position()}`],
  header: 'p-drawer-header',
  title: 'p-drawer-title',
  pcCloseButton: 'p-drawer-close-button',
  content: 'p-drawer-content',
  footer: 'p-drawer-footer'
};
let DrawerStyle = /*#__PURE__*/(() => {
  class DrawerStyle extends BaseStyle {
    name = 'drawer';
    style = style;
    classes = classes;
    static ɵfac = /* @__PURE__ */(() => {
      let ɵDrawerStyle_BaseFactory;
      return function DrawerStyle_Factory(__ngFactoryType__) {
        return (ɵDrawerStyle_BaseFactory || (ɵDrawerStyle_BaseFactory = i0.ɵɵgetInheritedFactory(DrawerStyle)))(__ngFactoryType__ || DrawerStyle);
      };
    })();
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: DrawerStyle,
      factory: DrawerStyle.ɵfac
    });
  }
  return DrawerStyle;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 *
 * Drawer is a panel component displayed as an overlay at the edges of the screen.
 *
 * [Live Demo](https://www.primeng.org/drawer)
 *
 * @module drawerstyle
 *
 */
var DrawerClasses = /*#__PURE__*/function (DrawerClasses) {
  /**
   * Class name of the mask element
   */
  DrawerClasses["mask"] = "p-drawer-mask";
  /**
   * Class name of the root element
   */
  DrawerClasses["root"] = "p-drawer";
  /**
   * Class name of the header element
   */
  DrawerClasses["header"] = "p-drawer-header";
  /**
   * Class name of the title element
   */
  DrawerClasses["title"] = "p-drawer-title";
  /**
   * Class name of the close button element
   */
  DrawerClasses["pcCloseButton"] = "p-drawer-close-button";
  /**
   * Class name of the content element
   */
  DrawerClasses["content"] = "p-drawer-content";
  return DrawerClasses;
}(DrawerClasses || {});
const DRAWER_INSTANCE = /*#__PURE__*/new InjectionToken('DRAWER_INSTANCE');
/**
 * Sidebar is a panel component displayed as an overlay at the edges of the screen.
 * @group Components
 */
let Drawer = /*#__PURE__*/(() => {
  class Drawer extends BaseComponent {
    componentName = 'Drawer';
    $pcDrawer = inject(DRAWER_INSTANCE, {
      optional: true,
      skipSelf: true
    }) ?? undefined;
    bindDirectiveInstance = inject(Bind, {
      self: true
    });
    onAfterViewChecked() {
      this.bindDirectiveInstance.setAttrs(this.ptm('host'));
    }
    /**
     * Target element to attach the overlay, valid values are "body" or a local ng-template variable of another element (note: use binding with brackets for template variables, e.g. [appendTo]="mydiv" for a div element having #mydiv as variable name).
     * @defaultValue 'self'
     * @group Props
     */
    appendTo = input(undefined, ...(ngDevMode ? [{
      debugName: "appendTo"
    }] : []));
    /**
     * The motion options.
     * @group Props
     */
    motionOptions = input(undefined, ...(ngDevMode ? [{
      debugName: "motionOptions"
    }] : []));
    computedMotionOptions = computed(() => {
      return {
        ...this.ptm('motion'),
        ...this.motionOptions()
      };
    }, ...(ngDevMode ? [{
      debugName: "computedMotionOptions"
    }] : []));
    /**
     * Whether to block scrolling of the document when drawer is active.
     * @group Props
     */
    blockScroll = false;
    /**
     * Inline style of the component.
     * @group Props
     */
    style;
    /**
     * Style class of the component.
     * @group Props
     */
    styleClass;
    /**
     * Aria label of the close icon.
     * @group Props
     */
    ariaCloseLabel;
    /**
     * Whether to automatically manage layering.
     * @group Props
     */
    autoZIndex = true;
    /**
     * Base zIndex value to use in layering.
     * @group Props
     */
    baseZIndex = 0;
    /**
     * Whether an overlay mask is displayed behind the drawer.
     * @group Props
     */
    modal = true;
    /**
     * Used to pass all properties of the ButtonProps to the Button component.
     * @group Props
     */
    closeButtonProps = {
      severity: 'secondary',
      text: true,
      rounded: true
    };
    /**
     * Whether to dismiss drawer on click of the mask.
     * @group Props
     */
    dismissible = true;
    /**
     * Whether to display the close icon.
     * @group Props
     * @deprecated use 'closable' instead.
     */
    showCloseIcon = true;
    /**
     * Specifies if pressing escape key should hide the drawer.
     * @group Props
     */
    closeOnEscape = true;
    /**
     * Transition options of the animation.
     * @group Props
     * @deprecated since v21.0.0. Use `motionOptions` instead.
     */
    transitionOptions = '150ms cubic-bezier(0, 0, 0.2, 1)';
    /**
     * The visible property is an input that determines the visibility of the component.
     * @defaultValue false
     * @group Props
     */
    get visible() {
      return this._visible ?? false;
    }
    set visible(value) {
      this._visible = value;
      if (this._visible && !this.modalVisible) {
        this.modalVisible = true;
      }
    }
    /**
     * Specifies the position of the drawer, valid values are "left", "right", "bottom" and "top".
     * @defaultValue 'left'
     * @group Props
     */
    position = input('left', ...(ngDevMode ? [{
      debugName: "position"
    }] : []));
    /**
     * Adds a close icon to the header to hide the dialog.
     * @defaultValue false
     * @group Props
     */
    fullScreen = input(false, ...(ngDevMode ? [{
      debugName: "fullScreen"
    }] : []));
    $enterAnimation = computed(() => this.fullScreen() ? 'p-drawer-enter-full' : `p-drawer-enter-${this.position()}`, ...(ngDevMode ? [{
      debugName: "$enterAnimation"
    }] : []));
    $leaveAnimation = computed(() => this.fullScreen() ? 'p-drawer-leave-full' : `p-drawer-leave-${this.position()}`, ...(ngDevMode ? [{
      debugName: "$leaveAnimation"
    }] : []));
    /**
     * Title content of the dialog.
     * @group Props
     */
    header;
    /**
     * Style of the mask.
     * @group Props
     */
    maskStyle;
    /**
     * Whether to display close button.
     * @group Props
     * @defaultValue true
     */
    closable = true;
    /**
     * Callback to invoke when dialog is shown.
     * @group Emits
     */
    onShow = new EventEmitter();
    /**
     * Callback to invoke when dialog is hidden.
     * @group Emits
     */
    onHide = new EventEmitter();
    /**
     * Callback to invoke when dialog visibility is changed.
     * @param {boolean} value - Visible value.
     * @group Emits
     */
    visibleChange = new EventEmitter();
    containerViewChild;
    closeButtonViewChild;
    initialized;
    _visible;
    _position = 'left';
    _fullScreen = false;
    modalVisible = false;
    container;
    mask;
    maskClickListener;
    documentEscapeListener;
    animationEndListener;
    _componentStyle = inject(DrawerStyle);
    onAfterViewInit() {
      this.initialized = true;
    }
    /**
     * Custom header template.
     * @group Templates
     */
    headerTemplate;
    /**
     * Custom footer template.
     * @group Templates
     */
    footerTemplate;
    /**
     * Custom content template.
     * @group Templates
     */
    contentTemplate;
    /**
     * Custom close icon template.
     * @group Templates
     */
    closeIconTemplate;
    /**
     * Custom headless template to replace the entire drawer content.
     * @group Templates
     */
    headlessTemplate;
    $appendTo = computed(() => this.appendTo() || this.config.overlayAppendTo(), ...(ngDevMode ? [{
      debugName: "$appendTo"
    }] : []));
    _headerTemplate;
    _footerTemplate;
    _contentTemplate;
    _closeIconTemplate;
    _headlessTemplate;
    templates;
    onAfterContentInit() {
      this.templates?.forEach(item => {
        switch (item.getType()) {
          case 'content':
            this._contentTemplate = item.template;
            break;
          case 'header':
            this._headerTemplate = item.template;
            break;
          case 'footer':
            this._footerTemplate = item.template;
            break;
          case 'closeicon':
            this._closeIconTemplate = item.template;
            break;
          case 'headless':
            this._headlessTemplate = item.template;
            break;
          default:
            this._contentTemplate = item.template;
            break;
        }
      });
    }
    onKeyDown(event) {
      if (event.code === 'Escape') {
        this.hide(false);
      }
    }
    show() {
      this.container?.setAttribute(this.$attrSelector, '');
      if (this.autoZIndex) {
        ZIndexUtils.set('modal', this.container, this.baseZIndex || this.config.zIndex.modal);
      }
      if (this.modal) {
        this.enableModality();
      }
      this.onShow.emit({});
      this.visibleChange.emit(true);
    }
    hide(emit = true) {
      if (emit) {
        this.onHide.emit({});
      }
      if (this.modal) {
        this.disableModality();
      }
    }
    close(event) {
      this.hide();
      this.visibleChange.emit(false);
      event.preventDefault();
    }
    enableModality() {
      const activeDrawers = this.document.querySelectorAll('[data-p-open="true"]');
      const activeDrawersLength = activeDrawers.length;
      const zIndex = activeDrawersLength == 1 ? String(parseInt(this.container.style.zIndex) - 1) : String(parseInt(activeDrawers[activeDrawersLength - 1].style.zIndex) - 1);
      if (!this.mask) {
        this.mask = this.renderer.createElement('div');
        if (this.mask) {
          const style = `z-index: ${zIndex};${this.getMaskStyle()}`;
          setAttribute(this.mask, 'style', style);
          setAttribute(this.mask, 'data-p', this.dataP);
          addClass(this.mask, this.cx('mask'));
        }
        if (this.dismissible) {
          this.maskClickListener = this.renderer.listen(this.mask, 'click', event => {
            if (this.dismissible) {
              this.close(event);
            }
          });
        }
        this.renderer.appendChild(this.document.body, this.mask);
        if (this.blockScroll) {
          blockBodyScroll();
        }
      }
    }
    getMaskStyle() {
      return this.maskStyle ? Object.entries(this.maskStyle).map(([key, value]) => `${key}: ${value}`).join('; ') : '';
    }
    disableModality() {
      if (this.mask) {
        !this.$unstyled() && removeClass(this.mask, 'p-overlay-mask-enter-active');
        !this.$unstyled() && addClass(this.mask, 'p-overlay-mask-leave-active');
        this.animationEndListener = this.renderer.listen(this.mask, 'animationend', this.destroyModal.bind(this));
      }
    }
    destroyModal() {
      this.unbindMaskClickListener();
      if (this.mask) {
        this.renderer.removeChild(this.document.body, this.mask);
      }
      if (this.blockScroll) {
        unblockBodyScroll();
      }
      this.unbindAnimationEndListener();
      this.mask = null;
    }
    onBeforeEnter(event) {
      this.container = event.element;
      this.appendContainer();
      this.show();
      if (this.closeOnEscape) {
        this.bindDocumentEscapeListener();
      }
    }
    onAfterLeave() {
      this.hide(false);
      ZIndexUtils.clear(this.container);
      this.unbindGlobalListeners();
      this.modalVisible = false;
      this.container = null;
    }
    appendContainer() {
      if (this.$appendTo() && this.$appendTo() !== 'self') {
        if (this.$appendTo() === 'body') {
          appendChild(this.document.body, this.container);
        } else {
          appendChild(this.$appendTo(), this.container);
        }
      }
    }
    bindDocumentEscapeListener() {
      const documentTarget = this.el ? this.el.nativeElement.ownerDocument : this.document;
      this.documentEscapeListener = this.renderer.listen(documentTarget, 'keydown', event => {
        if (event.which == 27) {
          if (parseInt(this.container?.style.zIndex) === ZIndexUtils.get(this.container)) {
            this.close(event);
          }
        }
      });
    }
    unbindDocumentEscapeListener() {
      if (this.documentEscapeListener) {
        this.documentEscapeListener();
        this.documentEscapeListener = null;
      }
    }
    unbindMaskClickListener() {
      if (this.maskClickListener) {
        this.maskClickListener();
        this.maskClickListener = null;
      }
    }
    unbindGlobalListeners() {
      this.unbindMaskClickListener();
      this.unbindDocumentEscapeListener();
    }
    unbindAnimationEndListener() {
      if (this.animationEndListener && this.mask) {
        this.animationEndListener();
        this.animationEndListener = null;
      }
    }
    onDestroy() {
      this.initialized = false;
      if (this.visible && this.modal) {
        this.destroyModal();
      }
      if (this.$appendTo() && this.container) {
        this.renderer.appendChild(this.el.nativeElement, this.container);
      }
      if (this.container && this.autoZIndex) {
        ZIndexUtils.clear(this.container);
      }
      this.container = null;
      this.unbindGlobalListeners();
      this.unbindAnimationEndListener();
    }
    get dataP() {
      return this.cn({
        'full-screen': this.position() === 'full',
        [this.position()]: this.position(),
        open: this.visible,
        modal: this.modal
      });
    }
    static ɵfac = /* @__PURE__ */(() => {
      let ɵDrawer_BaseFactory;
      return function Drawer_Factory(__ngFactoryType__) {
        return (ɵDrawer_BaseFactory || (ɵDrawer_BaseFactory = i0.ɵɵgetInheritedFactory(Drawer)))(__ngFactoryType__ || Drawer);
      };
    })();
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: Drawer,
      selectors: [["p-drawer"]],
      contentQueries: function Drawer_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, _c0, 4)(dirIndex, _c1, 4)(dirIndex, _c2, 4)(dirIndex, _c3, 4)(dirIndex, _c4, 4)(dirIndex, PrimeTemplate, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerTemplate = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.footerTemplate = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.contentTemplate = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.closeIconTemplate = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headlessTemplate = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.templates = _t);
        }
      },
      viewQuery: function Drawer_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c5, 5)(_c6, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.containerViewChild = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.closeButtonViewChild = _t.first);
        }
      },
      inputs: {
        appendTo: [1, "appendTo"],
        motionOptions: [1, "motionOptions"],
        blockScroll: [2, "blockScroll", "blockScroll", booleanAttribute],
        style: "style",
        styleClass: "styleClass",
        ariaCloseLabel: "ariaCloseLabel",
        autoZIndex: [2, "autoZIndex", "autoZIndex", booleanAttribute],
        baseZIndex: [2, "baseZIndex", "baseZIndex", numberAttribute],
        modal: [2, "modal", "modal", booleanAttribute],
        closeButtonProps: "closeButtonProps",
        dismissible: [2, "dismissible", "dismissible", booleanAttribute],
        showCloseIcon: [2, "showCloseIcon", "showCloseIcon", booleanAttribute],
        closeOnEscape: [2, "closeOnEscape", "closeOnEscape", booleanAttribute],
        transitionOptions: "transitionOptions",
        visible: "visible",
        position: [1, "position"],
        fullScreen: [1, "fullScreen"],
        header: "header",
        maskStyle: "maskStyle",
        closable: [2, "closable", "closable", booleanAttribute]
      },
      outputs: {
        onShow: "onShow",
        onHide: "onHide",
        visibleChange: "visibleChange"
      },
      features: [i0.ɵɵProvidersFeature([DrawerStyle, {
        provide: DRAWER_INSTANCE,
        useExisting: Drawer
      }, {
        provide: PARENT_INSTANCE,
        useExisting: Drawer
      }]), i0.ɵɵHostDirectivesFeature([i1.Bind]), i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c7,
      decls: 1,
      vars: 1,
      consts: [["container", ""], ["icon", ""], ["role", "complementary", "pFocusTrap", "", 3, "pBind", "pMotion", "pMotionAppear", "pMotionEnterActiveClass", "pMotionLeaveActiveClass", "pMotionOptions", "class", "style"], ["role", "complementary", "pFocusTrap", "", 3, "pMotionOnBeforeEnter", "pMotionOnAfterLeave", "keydown", "pBind", "pMotion", "pMotionAppear", "pMotionEnterActiveClass", "pMotionLeaveActiveClass", "pMotionOptions"], [4, "ngTemplateOutlet"], [3, "pBind", "ngClass"], [3, "pBind", "class", 4, "ngIf"], [3, "pt", "ngClass", "buttonProps", "ariaLabel", "unstyled", "onClick", "keydown.enter", 4, "ngIf"], [4, "ngIf"], [3, "pBind"], [3, "onClick", "keydown.enter", "pt", "ngClass", "buttonProps", "ariaLabel", "unstyled"], ["data-p-icon", "times", 4, "ngIf"], ["data-p-icon", "times"]],
      template: function Drawer_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵconditionalCreate(0, Drawer_Conditional_0_Template, 4, 13, "div", 2);
        }
        if (rf & 2) {
          i0.ɵɵconditional(ctx.modalVisible ? 0 : -1);
        }
      },
      dependencies: [CommonModule, i2.NgClass, i2.NgIf, i2.NgTemplateOutlet, Button, TimesIcon, SharedModule, Bind, FocusTrapModule, i3.FocusTrap, MotionModule, i4.MotionDirective],
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return Drawer;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DrawerModule = /*#__PURE__*/(() => {
  class DrawerModule {
    static ɵfac = function DrawerModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DrawerModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DrawerModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [Drawer, SharedModule, SharedModule]
    });
  }
  return DrawerModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { Drawer, DrawerClasses, DrawerModule, DrawerStyle };
